import DemoPageWrapper from "../../utils/DemoPageWrapper";
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";
const config = {
  props: [
    {
      prop: "event",
      description: "context事件",
      type: "Object",
      required: "true"
    },
    {
      prop: "menuData",
      description: "菜单数据",
      type: "Array"
    },
    {
      prop: "onMenuSelect",
      description: "选中菜单方法",
      type: "Function"
    },
    {
      prop: "closeOnSelect",
      description:
        " 选中后自动关闭;也可以设置为false，通过instance.destroy关闭",
      type: "Boolean",
      default: "true"
    }
  ],
  events: [],
  methods: [],
  slots: []
};
export default DemoPageWrapper(Demo, DemoSource, config);
